<script lang="ts">
    import Modal, {bind} from "../../../naui/modal/Modal.svelte";
    import {modal, modalOptions} from "../../stores";
    import MessageModal from "./MessageModal.svelte";
    import type {IModalAccept, IModalConfirm, IModalSendPrices} from "./modal.interface";
    import ConfirmModal from "./ConfirmModal.svelte";
    import LoadingBar from "./LoadingBar.svelte";
    import SendUpdatePrices from "../prices/SendUpdatePrices.svelte";


    export function openModal(params: IModalAccept) {
        modalOptions.set({
            closeButton: !!params.closeButton,
            closeOnEsc: !!params.closeOnEsc,
            closeOnOuterClick: !!params.closeOnOuterClick
        });
        modal.set(bind(
            MessageModal,
            {
                title: params.title,
                message: params.message,
                button: params.button,
                onCancel: params.onClose
            }
        ));
    }

    export function openConfirmModal(params: IModalConfirm) {
        modalOptions.set({
            closeButton: !!params.closeButton,
            closeOnEsc: !!params.closeOnEsc,
            closeOnOuterClick: !!params.closeOnOuterClick
        });
        modal.set(bind(
            ConfirmModal,
            {
                title: params.title,
                message: params.message,
                ok: params.ok,
                cancel: params.cancel,
                onAccept: params.onAccept,
                onCancel: params.onCancel
            }
        ));
    }

    export function openLoadingModal() {
        modalOptions.set({
            closeButton: false,
            closeOnEsc: false,
            closeOnOuterClick: false
        });
        modal.set(bind(
            LoadingBar,
            {
                message: 't'
            }
        ));
    }

    export function openSendUpdatePrices(params: IModalSendPrices) {
        modalOptions.set({
            closeButton: false,
            closeOnEsc: false,
            closeOnOuterClick: false
        });
        modal.set(bind(
            SendUpdatePrices,
            {
                ...params
            }
        ));
    }
</script>

<Modal show={$modal}
       options={$modalOptions}/>